import { Card, Row, Spin } from "antd";
import { IntervalSelector } from "../IntervalSelector";
import { memo, useCallback, useState } from "react";
import { useFetchData } from "./hooks/useFetchData";
import { Line } from "@ant-design/plots";
import { useDoubleLineChartConfig } from "../../hooks/useDoubleLineChartConfig";
import { CHART_DEFAULT, CHART_PAID_OFF } from "../../../../lib/constants";
import { DefaultLegend } from "../DefaultLegend";

type CorrespondenceProps = {
  data: any;
  isDataLoading: boolean;
  isRecalculated: boolean;
};

const Correspondence = ({
  data,
  isDataLoading,
  isRecalculated,
}: CorrespondenceProps) => {
  const [granularity, setGranularity] = useState<number>(1);

  const { data: chartData, isLoading } = useFetchData(
    granularity,
    isRecalculated,
  );

  const getColor = useCallback(({ type }: { type: string }): string => {
    return type === "Emails" ? CHART_PAID_OFF : CHART_DEFAULT;
  }, []);

  const { config } = useDoubleLineChartConfig(chartData, getColor);

  return (
    <Card className="dashboard-card top">
      <Row className="justify-space-between align-center">
        <p className="text my-0">Correspondence</p>
        <IntervalSelector value={granularity} onSelect={setGranularity} />
      </Row>
      <Row className="d-block h-100">
        {!isDataLoading && !isLoading ? (
          <Row className="d-block">
            <Row className="mb-6 mt-2">
              <Row className="d-block mr-6">
                <h3 className="h h3">{data[granularity].emails}</h3>
                <p className="my-0 text-sm title">emails sent</p>
              </Row>
              <Row className="d-block">
                <h3 className="h h3">{data[granularity].letters}</h3>
                <p className="my-0 text-sm title">letters printed</p>
              </Row>
            </Row>

            <Line {...config} />

            <DefaultLegend first="Emails" second="Letters" />
          </Row>
        ) : (
          <Row className="h-100 justify-center align-center">
            <Spin size="large" />
          </Row>
        )}
      </Row>
    </Card>
  );
};

export default memo(Correspondence);
